import { Button, Modal, TextBlock, Title } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from './WinMoreModal.module.scss';

export type TWinMoreModalProps = {
  ctaLabel?: string;
  isCtaDisabled?: boolean;
  isOpen: boolean;
  onAddFunds: () => void;
  onClose: () => void;
};

export function WinMoreModal({
  ctaLabel,
  isCtaDisabled = false,
  isOpen,
  onAddFunds,
  onClose,
}: TWinMoreModalProps) {
  const { t } = useTranslation('modals');
  const description = t('winMore.description');
  const resolvedCtaLabel = ctaLabel ?? t('winMore.cta');

  return (
    <Modal
      classNameModal={styles.modal}
      description={description}
      isOpen={isOpen}
      onBeforeClose={onClose}
      size="l"
      title={t('winMore.title')}
    >
      <div className={styles.shell} data-testid="win-more-modal">
        <div aria-hidden="true" className={styles.foregroundImage}></div>

        <div className={styles.content} data-testid="win-more-modal-scroll">
          <header className={styles.header}>
            <Title as="h2" className={styles.title} color="contrast">
              {t('winMore.heading')}
            </Title>

            <TextBlock className={styles.description} color="contrast">
              {description}
            </TextBlock>
          </header>

          <Button
            className={styles.actionButton}
            color="accent"
            data-testid="win-more-modal-cta"
            disabled={isCtaDisabled}
            onClick={onAddFunds}
            size="s"
            type="button"
            variant="filled"
          >
            {resolvedCtaLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
